<template>
  <ModalDialog :title="header">
    <template #activator="{ showPopUp }">
      <div>
        <BaseButton v-bind="$attrs" @click="showPopUp">
          <BaseIcon :icon="Icon.FILTER" class="h-5 w-5" />
          {{ $t("message.filter") }}
        </BaseButton>
        <div>
          <slot name="activatedFilters" />
        </div>
      </div>
    </template>

    <template #default="{ closePopUp }">
      <h2 v-if="title">
        {{ title }}
      </h2>

      <slot />

      <div class="mt-sm gap-sm flex justify-end">
        <BaseButton :tooltip-text="`${$t('message.shortcuts.shortcut')}: Esc`" @click="closePopUp">
          {{ $t("dialog.close") }}
        </BaseButton>

        <BaseButton
          @click="
            resetDialog();
            closePopUp();
          "
        >
          {{ $t("dialog.reset") }}
        </BaseButton>
      </div>
    </template>
  </ModalDialog>
</template>

<script lang="ts" setup>
import { Icon } from "../assets/icons/Icon";
import BaseButton from "../components/BaseButton.vue";
import BaseIcon from "../components/BaseIcon.vue";
import ModalDialog from "../components/ModalDialog.vue";

defineProps<{
  title?: undefined | string;
  header?: undefined | string;
}>();

const emit = defineEmits<{
  reset: [];
}>();

const resetDialog = () => {
  emit("reset");
};
</script>
